import React, { useMemo, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './quillEditorReadOnly.css'
import { Item  } from '../../services/Item';
import { USER_ROLES, getCurrentUser } from '../../services/User';
import { useParams } from 'react-router-dom';

const QuillEditorReadOnly = ({item} : {item: Item}) => {

    const params = useParams();
    const user = getCurrentUser();
   
    const modules = useMemo(
        () => ({
            "toolbar": false,
            clipboard: {
                matchVisual: false,
            },
        }),
        []
    );

    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "color",
        "width",
        "align",
        "float",
        "size"
    ];

    return <div className='quill-editor-read-only'>
        <ReactQuill
            theme="snow"
            value={item.content || ''}
            formats={formats}
            modules={modules}
            bounds={'.quill-editor-read-only'}
            readOnly={true}
            placeholder={(user.role===USER_ROLES.ADMIN_COUNTRY && params.country === user.country) ? 'Content is not added ...' : 'Content will be added soon...'}
        />
    </div>
}

export default QuillEditorReadOnly;